<ionic-selectable
  *ngIf="(labels$ | async)?.loading === false"
  [(ngModel)]="selectedLabels"
  [items]="(labels$ | async)?.data || []"
  itemValueField="id"
  itemTextField="label"
  [canSearch]="true"
  [hasInfiniteScroll]="true"
  [shouldStoreItemValue]="true"
  (onInfiniteScroll)="getMoreLabels($event)"
  (onSearch)="searchLabels($event)"
  closeButtonSlot="end"
  [isEnabled]="!disabled && !!(selectedZone$ | async)"
  #labelsSelectComponent
  [isMultiple]="true"
  itemIconSlot="end"
>
  <ng-template ionicSelectableValueTemplate let-labels="value">
    <div class="ionic-selectable-value-item label-icon" *ngFor="let label of labels">
      <ion-icon [src]="getIconForLabelByID(label)" color="primary" class="icon"></ion-icon>
      <ion-text color="primary" class="text">{{getLabelByID(label)}}</ion-text>
    </div>
  </ng-template>
  <ng-template ionicSelectableItemTemplate let-label="item" let-isLabelSelected="isItemSelected">
    <ion-icon [src]="getIconForLabel(label.label)" color="primary" class="label-icon ion-margin-end"></ion-icon>
    {{label.label}}
  </ng-template>
  <ng-template ionicSelectablePlaceholderTemplate>
    Labels
  </ng-template>
  <ng-template ionicSelectableFooterTemplate>
    <ion-toolbar>
      <ion-row>
        <ion-col>
          <ion-button expand="full" (click)="createLabel()">
            Create Label
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="full" (click)="selectLabels()">
            OK
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-toolbar>
  </ng-template>
</ionic-selectable>

<ion-spinner name="dots" *ngIf="(labels$ | async)?.loading"></ion-spinner>
